import anime from "animejs";
function hideMainNavigation(event) {
    const mainNavigationBar = document.getElementById("main_navigation");
    if (!mainNavigationBar)
        return;
    mainNavigationBar.classList.add("hidden");
}
function showMainNavigation(event) {
    const mainNavigationBar = document.getElementById("main_navigation");
    if (!mainNavigationBar)
        return;
    mainNavigationBar.classList.remove("hidden");
}
let mobileMenuVisible = false;
function showMobileMenu(event, preventDefault = false) {
    if (preventDefault)
        event.preventDefault();
    const menu = document.getElementById("mobile_nav_menu");
    if (!menu)
        return;
    // menu.style.display = "flex";
    // const buttonOn = document.querySelector("#mobile_nav_menu_button .on_state") as SVGElement;
    // const buttonOff = document.querySelector("#mobile_nav_menu_button .off_state") as SVGElement;
    //
    // if (!buttonOn || !buttonOff) return;
    //
    // buttonOn.style.display = "block";
    // buttonOff.style.display = "none";
    mobileMenuVisible = true;
    anime.set(menu, {
        display: "flex",
        translateX: 200,
    });
    anime({
        targets: menu,
        translateX: 0,
        easing: "easeOutCubic",
        duration: 160,
    });
}
function hideMobileMenu(event, preventDefault = false) {
    if (preventDefault)
        event.preventDefault();
    const menu = document.getElementById("mobile_nav_menu");
    if (!menu)
        return;
    menu.style.display = "none";
    mobileMenuVisible = false;
    //
    // const buttonOn = document.querySelector("#mobile_nav_menu_button .on_state") as SVGElement;
    // const buttonOff = document.querySelector("#mobile_nav_menu_button .off_state") as SVGElement;
    //
    // if (!buttonOn || !buttonOff) return;
    //
    // buttonOn.style.display = "none";
    // buttonOff.style.display = "block";
}
function toggleMobileMenu(event, preventDefault = false) {
    if (mobileMenuVisible)
        hideMobileMenu(event, preventDefault);
    else
        showMobileMenu(event, preventDefault);
}
export { showMobileMenu, hideMobileMenu, toggleMobileMenu, anime, hideMainNavigation, showMainNavigation };
//# sourceMappingURL=index.js.map